/**
 * OTRACK-SUBSYSTEM — `TT` ("Temporary Track Point") coordinate-input
 * keyword grammar.
 *
 * Distinct AutoCAD mechanism from the point filters in `pointFilterTokens.ts`
 * (FROM / M2P / `.X.Y.Z`): FROM/M2P compose ONE resolved point from a
 * base+offset or a midpoint; `TT` instead ARMS a temporary object-snap
 * tracking point — functionally identical to a hover-dwell acquisition —
 * and returns control to the SAME point prompt. It never itself produces
 * the command's resolved point. Kept in its OWN file (not folded into
 * `classifyPointFilterToken`) so the two grammars can never collide and the
 * already-shipped FROM/M2P/.X classifier stays byte-unchanged.
 *
 * Reference: Autodesk "Temporary Track Point" (`tt` command-line alias) —
 * "Specify a temporary point that will act as an object snap tracking
 * point." ezdxf has no group-code surface for this (pure input-resolution,
 * no DXF entity), same as FROM/M2P.
 */

/**
 * True when `input` is the `TT` starter token (case-insensitive, `_`/`'`
 * prefix tolerant — mirrors `classifyPointFilterToken`'s own prefix
 * handling for the international / transparent-command markers).
 */
export function classifyTemporaryTrackPointToken(input: string): boolean {
  const trimmed = input.trim();
  if (trimmed.length === 0) return false;
  const bare = trimmed.replace(/^['_]+/u, "");
  return bare.toUpperCase() === "TT";
}
